"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_TICKET_SEQUENCE = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_TICKET_SEQUENCE = (0, gql_1.gql)(`
  mutation TicketSequence($projectId: ID!, $tickets: [TicketInput!]!) {
    ticketSequence(project: $projectId, tickets: $tickets) {
      id
    }
  }
`);
